import styled from 'styled-components';

const Error = styled.div`
  color: ${({ theme }) => theme.error};
  margin-top: 5px;
  font-size: initial;
`;

export default Error;
